import { Route, Switch } from "react-router-dom";

import CustomerListComponent from "../../components/page/customer/CustomerListComponent";

export default function customerPage() {
  return (
    <Switch>
      <Route exact path="/customer/list" component={CustomerListComponent} />
    </Switch>
  );
}
